import { Label } from '@/components/ui/label'
import { PositionPicker } from '@/components/warehouse-positions/position-picker'
import { m } from '@/lib/paraglide/messages'

export { sendsNewLot } from '@/lib/return-new-lot'

export interface ShelfFieldProps {
    id: string
    label: string
    value: string | undefined
    onChange: (id: string) => void
    placeholder: string
    fallbackLabel?: string
    error?: string
    /** Vị trí hiện tại của lô: chọn đúng kệ này mới có ô "Tạo lô mới". */
    currentPositionId?: string
    newLot: boolean
    newLotLabel: string
    onNewLotChange: (checked: boolean) => void
}

// Một dòng "<nhãn>: [chọn kệ]" dưới mỗi lô, lỗi (nếu có) ngay dưới ô chọn.
export function ShelfField({
    id,
    label,
    value,
    onChange,
    placeholder,
    fallbackLabel,
    error,
    currentPositionId,
    newLot,
    newLotLabel,
    onNewLotChange,
}: ShelfFieldProps) {
    const errorId = `${id}-error`
    const onCurrentShelf = Boolean(value) && value === currentPositionId
    return (
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <Label
                htmlFor={id}
                className="w-40 shrink-0 text-xs text-muted-foreground"
            >
                {label}
            </Label>
            <div className="w-full sm:w-72">
                <PositionPicker
                    id={id}
                    lotType="product"
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    fallbackLabel={fallbackLabel}
                />
                {error && (
                    <p id={errorId} className="mt-1 text-xs text-destructive">
                        {error}
                    </p>
                )}
            </div>
            {onCurrentShelf ? (
                <label className="flex cursor-pointer items-center gap-2 text-xs">
                    <input
                        type="checkbox"
                        className="h-4 w-4 cursor-pointer"
                        checked={newLot}
                        aria-label={newLotLabel}
                        onChange={(e) => onNewLotChange(e.target.checked)}
                    />
                    {m.confirm_return_new_lot_text()}
                </label>
            ) : (
                value && (
                    <span className="text-xs text-muted-foreground">
                        {m.confirm_return_new_lot_forced()}
                    </span>
                )
            )}
        </div>
    )
}
